<template>
  <div class="wiki-list">
    <div class="title">
      <div class="tabs">
        <div class="tab-item" :class="{ active: active == 0 }" @click="handleChangeActive(0)">热门wiki</div>
        <div class="tab-item" :class="{ active: active == 1 }" @click="handleChangeActive(1)">最新wiki</div>
      </div>
      <a class="more" href="/wikis" target="_blank" @click="handleBury">更多</a>
    </div>
    <div class="content">
      <div class="list hot-list" v-show="active == 0">
        <a
          class="item"
          v-for="item in hotList.slice(0, 9)"
          :key="item.game_id"
          :href="getJumpWikiUrl(item.alias, item.game_id, true)"
          target="_blank"
          @click="handleBury"
        >
          <div class="wiki-icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="wiki-name" :title="item.game_name">{{ item.game_name }}</div>
        </a>
      </div>
      <div class="list hot-list" v-show="active == 1">
        <a
          class="item"
          v-for="item in newList.slice(0, 9)"
          :key="item.id"
          :href="getJumpWikiUrl(item.alias, item.id, true)"
          target="_blank"
          @click="handleBury"
        >
          <div class="wiki-icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="wiki-name" :title="item.name">{{ item.name }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { getJumpWikiUrl } from "@/plugins/util";
export default {
  name: "NewWikiList",
  props: {
    hotList: {
      type: Array,
      default: () => []
    },
    newList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      active: 0
    };
  },
  methods: {
    dayjs,
    getJumpWikiUrl,
    handleChangeActive(index) {
      this.active = index;
      this.handleBury();
    },
    handleBury() {
      if (window.staticFn) {
        console.log("点击", "click_new_home_wiki");
        if (this.$route.name === "wwwNewHome") {
          window.staticFn.customEvent("click_new_home_wiki");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wiki-list {
  margin-bottom: 57px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 34px;
    .tabs {
      display: flex;
      align-items: center;
      gap: 25px;
      .tab-item {
        width: 118px;
        height: 38px;
        border-radius: 56px 56px 56px 56px;
        border: 1px solid #ececec;
        font-weight: 400;
        font-size: 20px;
        color: #999999;
        text-align: center;
        line-height: 38px;
        cursor: pointer;
        &.active {
          font-weight: 500;
          color: #139cfa;
          background: #dcf5ff;
          border: 1px solid #dcf5ff;
        }
      }
    }
    .more {
      width: 57px;
      height: 30px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #d7d7d7;
      font-weight: 400;
      font-size: 16px;
      color: #444444;
      text-align: center;
      line-height: 30px;
    }
  }

  .content {
    .list {
      display: flex;
      align-items: center;
      gap: 51px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 110px;

        .wiki-icon {
          width: 110px;
          height: 110px;
          border-radius: 20px 20px 20px 20px;
          margin-bottom: 14px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 0.2s;
            &:hover {
              transform: scale(1.05);
            }
          }
        }
        .wiki-name {
          display: block;
          width: 126px;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          text-align: center;
          line-height: 22px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
